<div class="ss-file-picker" [class.is-disabled]="disabled">
  <div class="ss-file-picker__row">
    <input
      #fileInput
      [id]="inputId"
      type="file"
      class="ss-file-picker__input"
      [accept]="accept"
      [disabled]="disabled"
      [attr.aria-label]="ariaLabel || null"
      [attr.aria-describedby]="inputId + '-name' + (hint ? ' ' + inputId + '-hint' : '')"
      (change)="choose($event)">
    <label [for]="inputId" class="ss-file-picker__button">
      <lucide-icon name="upload" [size]="16" aria-hidden="true"></lucide-icon>
      {{ buttonLabel }}
    </label>
    <span [id]="inputId + '-name'" class="ss-file-picker__name" [class.is-empty]="!fileName">{{ fileName || emptyLabel }}</span>
  </div>
  <span *ngIf="hint" [id]="inputId + '-hint'" class="ss-file-picker__hint">{{ hint }}</span>
</div>
